export default "__VITE_ASSET__kTNMey7j__"